"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var PaymentIcons = /** @class */ (function (_super) {
    __extends(PaymentIcons, _super);
    function PaymentIcons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildItems = function (methods, types) {
            return methods && methods.length && types && types.length
                ? methods.map(function (method, i) { return (React.createElement("li", { key: i, className: "mr-0-8 flex items-center ms:px-2 px-1 " + (_this.props.iconHeight ? "h-" + _this.props.height : "h-3") + " py-0-6 bg-arctic rounded" },
                    React.createElement(Snippets.Svg, { name: "payment-" + method, height: _this.props.iconHeight ? _this.props.iconHeight : 14, className: "block" }))); })
                : [];
        };
        return _this;
    }
    PaymentIcons.prototype.render = function () {
        var _a = this.props.data, settings = _a.settings, shop = _a.shop;
        return shop.enabled_payment_types &&
            shop.enabled_payment_types.length &&
            settings &&
            settings.payment_methods &&
            settings.payment_methods.includes(",") ? (React.createElement("ul", { className: "list-reset flex items-center justify-start" }, this.buildItems(settings.payment_methods.split(","), shop.enabled_payment_types))) : null;
    };
    return PaymentIcons;
}(React.PureComponent));
exports.PaymentIcons = PaymentIcons;
